import { UserActionTypes } from "./constants"

const GET_USER_DATA_INITIAL_STATE = {
    userData: [],
    loading: false
}
const CREATE_USER_DATA_INITIAL_STATE = {
    createUserData: [],
    loading: false
}

const UPDATE_USER_DATA_INITIAL_STATE = {
    updateUserData: [],
    loading: false,
};
const DELETE_USER_DATA_INITIAL_STATE = {
    deleteUserData: [],
    loading: false,
};

const userDataReducer = (state = GET_USER_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case UserActionTypes.USER_DATA_LOADING:
            return {
                userData: state.userData,
                loading: true
            }
        case UserActionTypes.USER_DATA_SUCCESS:
            return {
                userData: action.payload,
                loading: false
            }
        case UserActionTypes.USER_DATA_ERROR:
            return {
                userData: action.payload,
                loading: false
            }
        default: return state
    }
}


const createUserDataReducer = (state = CREATE_USER_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case UserActionTypes.CREATE_USER_DATA_LOADING:
            return {
                createUserData: state.createUserData,
                loading: true
            }
        case UserActionTypes.CREATE_USER_DATA_SUCCESS:
            return {
                createUserData: action.payload,
                loading: false
            }
        case UserActionTypes.CREATE_USER_DATA_ERROR:
            return {
                createUserData: action.payload,
                loading: false
            }
        case UserActionTypes.STATE_EMPTY_FIRST:
            return { ...CREATE_USER_DATA_INITIAL_STATE };
        default: return state
    }
}

const updateUserDataReducer = (state = UPDATE_USER_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case UserActionTypes.UPDATE_USER_DATA_LOADING:
            return {
                updateUserData: action.payload,
                loading: true,
            };
        case UserActionTypes.UPDATE_USER_DATA_SUCCESS:
            return {
                updateUserData: action.payload,
                loading: false,
            };
        case UserActionTypes.UPDATE_USER_DATA_ERROR:
            return {
                updateUserData: action.payload ,
                loading: false,
            };
        case UserActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_USER_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const deleteUserDataReducer = (state = DELETE_USER_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case UserActionTypes.DELETE_USER_DATA_LOADING:
            return {
                deleteUserData: action.payload,
                loading: true,
            };
        case UserActionTypes.DELETE_USER_DATA_SUCCESS:
            return {
                deleteUserData: action.payload,
                loading: false,
            };
        case UserActionTypes.DELETE_USER_DATA_ERROR:
            return {
                deleteUserData: action.payload ,
                loading: false,
            };
        case UserActionTypes.STATE_EMPTY_FIRST:
            return { ...DELETE_USER_DATA_INITIAL_STATE };
        default:
            return state;
    }
};



export {
    userDataReducer, createUserDataReducer, updateUserDataReducer, deleteUserDataReducer
}